import { JSONSchema7 } from 'json-schema';
import { injectImageOptionsToSchema } from './QuoteExperienceProcessor';

export type SchemaProcessorContext = {
    availableImages?: string[];
};

export type SchemaProcessor = (
    schema: JSONSchema7,
    context: SchemaProcessorContext
) => JSONSchema7;

export const schemaProcessorRegistry: Record<string, SchemaProcessor> = {
    'QUOTE_EXPERIENCE_IMAGES': (schema, context) =>
        injectImageOptionsToSchema(schema, context.availableImages ?? []),
    'QUOTE_EXPERIENCE_ICONS': (schema, context) =>
        injectImageOptionsToSchema(schema, context.availableImages ?? []),
};
export const processSchema = (
    schemaType: string,
    schema: JSONSchema7,
    context: SchemaProcessorContext
): JSONSchema7 => {
    const processor = schemaProcessorRegistry[schemaType];
    if (processor) {
        return processor(schema, context);
    }
    return schema;
};

export const hasCustomProcessor = (schemaType: string): boolean => {
    return schemaType in schemaProcessorRegistry;
};
